import {FC, useEffect, useState} from 'react'
import {connect, ConnectedProps} from 'react-redux'
import {LayoutSplashScreen} from '../../../../_metronic/layout/core'
import * as location from './LocationRedux'
import {RootState} from '../../../../setup'

const mapState = (state: RootState) => ({location: state.location})
const connector = connect(mapState, location.actions)
type PropsFromRedux = ConnectedProps<typeof connector>

const LocationInit: FC<PropsFromRedux> = (props) => {
  const [showSplashScreen, setShowSplashScreen] = useState(true)

  // We should request user by authToken before rendering the application
  useEffect(() => {}, [])

  return showSplashScreen ? <LayoutSplashScreen /> : <>{props.children}</>
}

export default connector(LocationInit)
